module.exports = __webpack_public_path__ + "img/ic_locked_meeting.f6abfc47.svg";